import { Loader, type LucideIcon } from 'lucide-react';

import { cn, Tooltip, TooltipContent, TooltipTrigger } from 'shared-ui';

interface MapControlButtonProps {
    icon: LucideIcon;
    label: string;
    onClick: () => void;
    isActive?: boolean;
    disabled?: boolean;
    isLoading?: boolean;
}

export function MapControlButton({ icon: Icon, label, onClick, isActive, disabled, isLoading }: MapControlButtonProps) {
    return (
        <Tooltip>
            <TooltipTrigger
                render={
                    <button
                        type="button"
                        aria-label={label}
                        aria-pressed={isActive}
                        aria-disabled={disabled}
                        disabled={disabled}
                        onClick={onClick}
                        className={cn(
                            'bg-background flex size-10 cursor-pointer items-center justify-center rounded-md border shadow-sm transition-colors',
                            'focus-visible:ring-origin-blue/50 focus-visible:ring-3 focus-visible:outline-none',
                            'disabled:pointer-events-none disabled:opacity-50',
                            'hover:bg-accent hover:text-accent-foreground',
                            isActive ? 'border-origin-blue bg-secondary border-2' : 'border-border',
                        )}
                    >
                        {isLoading ? (
                            <Loader className="text-origin-blue size-4 animate-spin" />
                        ) : (
                            <Icon className="text-origin-blue size-4" />
                        )}
                    </button>
                }
            />
            <TooltipContent side="left">{label}</TooltipContent>
        </Tooltip>
    );
}
